export const REGEX_SHORT_URL_ID = /\/(j|private-join)\/(\d+)$/;

export const getShortUrlIdFromUrl = (url: string) => {
    const match = url.match(REGEX_SHORT_URL_ID);

    if (!match || match.length < 3) {
        return null;
    }

    return match[2];
};
